import { useCheckSiniestro } from './useCheckSiniestro'
import { useTopDenunciantes } from './useTopDenunciantes'
import { useTopJudiciales } from './useTopJudiciales'
import { useTopEvolucionSiniestros } from './useTopEvolucionSiniestros'
import { useTopRankingSiniestros } from './useTopRankingSiniestros'
import { useIndicadores } from './useIndicadores'
import { useGraficosTipoAccidente } from './useGraficosTipoAccidente'
import { useGraficosGravedad } from './useGraficosGravedad'
import { useGraficosDenuncias } from './useGraficosDenuncias'

export const useInformeData = (reportTrigger, reportData, periodoData, contrato) => {
  const checkSiniestro = useCheckSiniestro(reportTrigger, periodoData, contrato)
  const dataTrigger = checkSiniestro.validatedTrigger

  const topDenunciantes = useTopDenunciantes(dataTrigger, contrato)
  const topJudiciales = useTopJudiciales(dataTrigger, contrato)
  const topEvolucionSiniestros = useTopEvolucionSiniestros(dataTrigger, periodoData, contrato)
  const topRankingSiniestros = useTopRankingSiniestros(dataTrigger, reportData, contrato)
  const indicadores = useIndicadores(dataTrigger, reportData, periodoData, contrato)
  const graficosTipoAccidente = useGraficosTipoAccidente(dataTrigger, reportData, contrato)
  const graficosGravedad = useGraficosGravedad(dataTrigger, reportData, contrato)
  const graficosDenuncias = useGraficosDenuncias(dataTrigger, reportData, contrato)

  const isLoading =
    checkSiniestro.isLoading ||
    topDenunciantes.isLoading ||
    topJudiciales.isLoading ||
    topEvolucionSiniestros.isLoading ||
    topRankingSiniestros.isLoading ||
    indicadores.isLoading ||
    graficosTipoAccidente.isLoading ||
    graficosGravedad.isLoading ||
    graficosDenuncias.isLoading

  const hasServiceError = !!(
    topDenunciantes.error ||
    topJudiciales.error ||
    topEvolucionSiniestros.error ||
    topRankingSiniestros.error ||
    indicadores.error ||
    graficosTipoAccidente.error ||
    graficosGravedad.error ||
    graficosDenuncias.error
  )

  return {
    isLoading,
    hasData: checkSiniestro.hasData,
    isChecking: checkSiniestro.isLoading,
    hasCheckError: checkSiniestro.error,
    hasServiceError,
    topDenunciantes,
    topJudiciales,
    topEvolucionSiniestros,
    topRankingSiniestros,
    indicadores,
    graficosTipoAccidente,
    graficosGravedad,
    graficosDenuncias,
  }
}
